import React from "react";

export default function ProphetMuhammadFrame1({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-prop11{fill:#fff}.cls-prop12{fill:#d8a023}.cls-prop13{fill:#60008c}"
            }
          </style>
        </defs>
        <path
          d="M1050.35 1424.83c-5.05 23.84-26.22 41.73-51.56 41.73-29.11 0-52.71-23.6-52.71-52.71s23.6-52.72 52.71-52.72c2.43 0 4.82.16 7.17.49-20.73 3.12-36.63 21.02-36.63 42.63 0 23.82 19.31 43.13 43.12 43.13 16.36 0 30.6-9.12 37.91-22.55Z"
          className="cls-prop13"
        />
        <path
          d="M1000 80.54C492.19 80.54 80.54 492.2 80.54 1000c0 320.48 163.97 602.67 412.6 767.25a918.222 918.222 0 0 0 88.88 51.93 908.311 908.311 0 0 0 51.82 24.48 910.873 910.873 0 0 0 128.81 44.88c75.72 20.17 155.28 30.93 237.35 30.93 77.24 0 152.26-9.53 223.94-27.47a911.232 911.232 0 0 0 142.2-48.33c16.64-7.22 33-14.92 49.1-23.09a915.947 915.947 0 0 0 76.67-43.64c256.98-163.04 427.54-450.07 427.54-776.93 0-507.8-411.65-919.46-919.45-919.46Zm17.31 1424.67c-5.35 0-10.69-.06-16.03-.19l-1.59-14.47c0-2.62-1.15-4.94-2.88-6.27l-1.26-15.1c0-1.46-1-2.63-2.25-2.63s-2.25 1.18-2.25 2.63c-.44 5.05-.89 10.12-1.34 15.17-1.69 1.34-2.8 3.62-2.8 6.2-.52 4.64-1.04 9.28-1.57 13.92-360.46-16.69-647.59-314.21-647.59-678.82S642.01 146.1 1017.31 146.1s679.57 304.25 679.57 679.56-304.25 679.56-679.57 679.56Z"
          className="cls-prop13"
        />
        <path
          d="m999.7 1490.56 1.59 14.47c-5.33-.12-10.65-.3-15.94-.55.53-4.64 1.05-9.28 1.57-13.92 0-2.58 1.11-4.86 2.8-6.2.45-5.05.9-10.12 1.34-15.17 0-1.46 1.01-2.63 2.25-2.63s2.25 1.18 2.25 2.63l1.26 15.1c1.74 1.33 2.88 3.65 2.88 6.27Z"
          className="cls-prop11"
        />
        <path
          d="M1050.35 1424.83c-5.05 23.84-26.22 41.73-51.56 41.73-29.11 0-52.71-23.6-52.71-52.71s23.6-52.72 52.71-52.72c2.43 0 4.82.16 7.17.49-20.73 3.12-36.63 21.02-36.63 42.63 0 23.82 19.31 43.13 43.12 43.13 16.36 0 30.6-9.12 37.91-22.55Z"
          className="cls-prop11"
        />
        <path
          d="M1223.95 1853.55v38.44c-71.68 17.95-146.7 27.47-223.94 27.47-82.07 0-161.62-10.75-237.35-30.93v-34.99c0-3.33.13-6.62.38-9.89.63-8.41 2.07-16.6 4.23-24.48 3.39-12.34 8.56-23.94 15.22-34.51 16.5-26.2 42.12-46.08 72.42-55.15 11.78-3.53 24.28-5.43 37.21-5.43h202.36c12.94 0 25.43 1.9 37.21 5.44 27.44 8.22 51.04 25.29 67.51 47.91a128.938 128.938 0 0 1 20.12 41.75 128.25 128.25 0 0 1 4.23 24.48c.25 3.27.38 6.57.38 9.89Z"
          className="cls-prop12"
        />
        <rect
          width={292.15}
          height={136.68}
          x={847.23}
          y={1629.68}
          className="cls-prop12"
          rx={68.34}
          ry={68.34}
        />
        <rect
          width={278.7}
          height={32.6}
          x={853.95}
          y={1613.38}
          className="cls-prop12"
          rx={15.18}
          ry={15.18}
        />
        <path
          d="M1095.69 1629.68h-204.8v-3.95c.07-6.38 1.18-36.93 29.99-61.4 13.22-11.23 27.81-17.38 39.61-20.78 13.5-3.89 24.35-12.53 29.62-23.76.96-2.04 1.92-4.08 2.87-6.12.47-1.01 2.17-1 2.63.02l2.78 6.18c5.08 11.27 15.77 20.03 29.16 24.09 11.46 3.47 25.44 9.57 38.14 20.37 30.6 26.02 30.19 59.29 29.99 65.34Z"
          className="cls-prop12"
        />
        <rect
          width={40.34}
          height={15}
          x={973.13}
          y={1523.4}
          className="cls-prop12"
          rx={6.92}
          ry={6.92}
        />
        <path
          d="M1003.39 1524.1c-.08.13-.57.99-1.45 2.02-1.61 1.88-4.52 4.38-8.64 4.3-3.35-.06-5.85-1.79-7.52-3.52-1.64-1.68-2.49-3.36-2.56-3.51.71-6.31 1.43-12.61 2.13-18.92.53-4.64 1.05-9.28 1.57-13.92 0-2.58 1.11-4.86 2.8-6.2 1.01-.82 2.26-1.3 3.59-1.3s2.5.45 3.51 1.23c1.74 1.33 2.88 3.65 2.88 6.27l1.59 14.47c.68 6.12 1.35 12.25 2.03 18.37.03.23.05.47.08.7Z"
          className="cls-prop12"
        />
        <path
          d="M998.22 1501.02c-.4.42-2.19 2.23-4.92 2.23s-4.67-1.97-5.04-2.38c.49-5.51.97-11 1.46-16.51.45-5.05.9-10.12 1.34-15.17 0-1.46 1.01-2.63 2.25-2.63s2.25 1.18 2.25 2.63l1.26 15.1 1.41 16.73Z"
          className="cls-prop12"
        />
        <path
          d="M1050.35 1424.83c-5.05 23.84-26.22 41.73-51.56 41.73-29.11 0-52.71-23.6-52.71-52.71s23.6-52.72 52.71-52.72c2.43 0 4.82.16 7.17.49-20.73 3.12-36.63 21.02-36.63 42.63 0 23.82 19.31 43.13 43.12 43.13 16.36 0 30.6-9.12 37.91-22.55ZM799.93 1843.65H633.85a908.311 908.311 0 0 1-51.82-24.48 917.022 917.022 0 0 1-88.88-51.93c5.12-5.27 11.1-10.47 18.05-15.5 21.84-15.8 45.93-24.45 65.43-29.22 9.03-2.21 17.35-5.54 24.63-9.74 6.67-3.87 12.47-8.48 17.14-13.68 1.44-1.59 2.76-3.25 3.96-4.95 1.18-1.64 2.24-3.32 3.19-5.04l4.74-8.61c.79-1.42 3.59-1.41 4.34.02l4.6 8.69c.9 1.69 1.9 3.35 3 4.95a57.7 57.7 0 0 0 2.86 3.83c4.34 5.27 9.79 10 16.13 14.01 7.59 4.8 16.44 8.59 26.17 11.1 18.93 4.88 42.02 13.46 62.99 28.65 14.51 10.51 24.81 21.86 32.09 32.91 8.22 12.44 12.61 24.49 14.95 34.51 2.81 12.05 2.63 21.17 2.5 24.48Z"
          className="cls-prop12"
        />
        <rect
          width={66.63}
          height={21.1}
          x={597.51}
          y={1694.16}
          className="cls-prop12"
          rx={10.55}
          ry={10.55}
        />
        <path
          d="M614.17 1694.16c2.04-15.4 4.07-30.79 6.11-46.19 0-5.83 4.72-10.55 10.55-10.55s10.55 4.72 10.55 10.55c2.04 15.72 4.07 31.45 6.11 47.17-.35.54-6.11 9.07-16.66 8.91-10.9-.17-16.41-9.45-16.66-9.89Z"
          className="cls-prop12"
        />
        <path
          d="m622.5 1662.47 4.62-44.56c0-2.05 1.66-3.71 3.71-3.71s3.71 1.66 3.71 3.71l4.41 44.77c-.67.61-3.61 3.15-8.12 3.14-4.7 0-7.71-2.76-8.33-3.36Z"
          className="cls-prop12"
        />
        <path
          d="M661.24 1590.18c-2.95 13.91-15.3 24.34-30.08 24.34-16.98 0-30.75-13.77-30.75-30.75s13.77-30.75 30.75-30.75c1.42 0 2.82.09 4.18.28-12.09 1.83-21.37 12.27-21.37 24.87 0 13.89 11.26 25.16 25.15 25.16 9.55 0 17.85-5.32 22.11-13.15ZM1491.92 1776.93a914.353 914.353 0 0 1-76.67 43.64 912.054 912.054 0 0 1-49.1 23.09h-189.49v-5.55c.04-3.01.27-9.86 2.36-18.93 2.64-11.46 8.25-26.45 20.2-41.75 6.76-8.66 15.55-17.42 26.97-25.68 21.84-15.8 45.94-24.45 65.43-29.22 9.04-2.21 17.35-5.54 24.63-9.74 6.67-3.87 12.46-8.48 17.13-13.68 1.44-1.59 2.77-3.25 3.97-4.95 1.18-1.64 2.24-3.32 3.19-5.04l4.74-8.61c.78-1.42 3.58-1.41 4.34.02l4.59 8.69c.9 1.69 1.9 3.35 3 4.95a57.7 57.7 0 0 0 2.86 3.83c4.34 5.27 9.79 9.99 16.13 14 7.59 4.81 16.45 8.6 26.18 11.11 18.92 4.88 42.02 13.46 62.99 28.65 11.15 8.07 19.8 16.64 26.52 25.18Z"
          className="cls-prop12"
        />
        <rect
          width={66.63}
          height={21.1}
          x={1312.51}
          y={1694.16}
          className="cls-prop12"
          rx={10.55}
          ry={10.55}
        />
        <path
          d="M1329.17 1694.16c2.04-15.4 4.07-30.79 6.11-46.19 0-5.83 4.72-10.55 10.55-10.55s10.55 4.72 10.55 10.55c2.04 15.72 4.07 31.45 6.11 47.17-.35.54-6.11 9.07-16.66 8.91-10.9-.17-16.41-9.45-16.66-9.89Z"
          className="cls-prop12"
        />
        <path
          d="m1337.5 1662.47 4.62-44.56c0-2.05 1.66-3.71 3.71-3.71s3.71 1.66 3.71 3.71l4.41 44.77c-.67.61-3.61 3.15-8.12 3.14-4.7 0-7.71-2.76-8.33-3.36Z"
          className="cls-prop12"
        />
        <path
          d="M1376.24 1590.18c-2.95 13.91-15.3 24.34-30.08 24.34-16.98 0-30.75-13.77-30.75-30.75s13.77-30.75 30.75-30.75c1.42 0 2.82.09 4.18.28-12.09 1.83-21.37 12.27-21.37 24.87 0 13.89 11.26 25.16 25.15 25.16 9.55 0 17.85-5.32 22.11-13.15ZM1415.25 1819.18v1.39a912.054 912.054 0 0 1-49.1 23.09 909.509 909.509 0 0 1-142.2 48.33c-71.68 17.95-146.7 27.47-223.94 27.47-82.07 0-161.62-10.75-237.35-30.93a910.873 910.873 0 0 1-128.81-44.88 908.311 908.311 0 0 1-51.82-24.48h833.23Z"
          className="cls-prop12"
        />
        {children}
      </g>
    </svg>
  );
}
